

angular.module('admin')

/* 
 * Tworzenie fragmentu witryny tak jakby użyć stanu module.detail.tab
 * params
 * load-module="name or id" - specyfikacja modułu do załadowania
 * parent-context="mCtrl.ListContext" - obiekt jako kontekst
 * parent-object="mCtrl.Object" - obiekt jako kontekst
 */ 
.directive('loadModule', function(ContextService, $controller) {
	return {
		template: '<div class="v-grow" ng-include="loadModuleTemplateUrl"></div>',
		restrict: 'EA',
		scope: true,
		link: function(scope, element, attrs){
			//console.log(scope.aliases);
			var tab_name = scope.$eval(attrs.loadModule);
			var ParentObject = scope.$eval(attrs.parentObject);
			var ParentContext = scope.$eval(attrs.parentContext);
			if (ParentContext && ParentObject) {
				var ListContext = ParentContext.getReferencedContext(ParentObject, tab_name)
			} else {
				var ListContext = ContextService.getContext(tab_name)
			}
			if (!ListContext) throw "No module for load-module";
			
			var controller = ListContext.config.listController || 'ModuleListController';
			var controllerAs = ListContext.config.listControllerAs || 'tCtrl';
			var templateUrl = ListContext.config.tabTemplateUrl || 'framework/partials/admin/tab-list.html'
			
			ListContext.fetchBaseFilter().then(function(BaseFilter){
				var ctrl = $controller(controller, {$scope:scope, ListContext:ListContext, BaseFilter:BaseFilter});
				scope[controllerAs] = ctrl;
				scope.loadModuleTemplateUrl = templateUrl;
				console.log('loaded', ListContext);
			}); 

			
		}
		
	}
	/**/ 
})

